import HNSColors from "../../../ui library/HNSColors";

export const PAYMENTS_MODAL_STYLES = {
  textField: {
    "& .MuiOutlinedInput-root": {
      padding: 0,
      borderRadius: "8px",
      transition: "border-color 0.3s",
      "& fieldset": { borderColor: HNSColors.neutrals[400] },
      "&.Mui-focused fieldset": { border: `1.5px solid ${HNSColors.secondary[500]}` },
      "& .MuiInputBase-input": { padding: "8px" },
      "& .MuiSelect-icon": { color: HNSColors.primary[500] },
    },
  },
  datePickerTextField: {
    "& .MuiOutlinedInput-root": {
      padding: 0,
      borderRadius: "8px",
      transition: "border-color 0.3s",
      "& fieldset": { borderColor: HNSColors.neutrals[400] },
      "&.Mui-focused fieldset": { border: `1.5px solid ${HNSColors.secondary[500]}` },
      "& .MuiInputBase-input": { padding: "8px" },
      "& .MuiSelect-icon": { color: HNSColors.primary[500] },
    },
  },
  dropdownPaper: {
    marginTop: 1,
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    color: HNSColors.neutrals[100],
    border: `1.5px solid ${HNSColors.secondary[500]}`,
    "& .MuiList-root": { padding: 0 },
  },
};
